import {PayloadAction} from "@reduxjs/toolkit";
import {PagingDataModel} from "../../pages/shared/models/paging-data.model";
import {OrderModel} from "../../pages/shared/models/order/order-item.model";
import {OrdersResponseModel} from "../../pages/shared/models/api/orders-response.model";
import {OrderViewEnum} from "../../pages/orders/enums/order/view.enum";
import {OrderFilterModel} from "../../pages/shared/models/order/order-filter.model";
import {AllOrdersResponseModel} from "../../pages/shared/models/api/all-orders-response.model";

export function changeOrdersTab (state: OrdersState, action: PayloadAction<number>): void {
    if (state.tabId !== action.payload) {
        state.tabId = action.payload;

        state.ordersData.orders = [];
        state.ordersData.currentPage = 0;
        state.ordersData.totalItems = 0;
    }
}

export function changeOrdersType (state: OrdersState, action: PayloadAction<number | string>): void {
    if (state.orderStateId !== action.payload) {
        state.orderStateId = action.payload;
        state.ordersData.orders = [];
        state.ordersData.currentPage = 0;
        state.ordersData.totalItems = 0;
    }
}

export function onPaginationChange (state: OrdersState, action: PayloadAction<PagingDataModel>): void {
    state.ordersData.pageSize = action.payload.pageSize;
    state.ordersData.currentPage = action.payload.currentPage;
}

export function onChangeOrderInState (state: OrdersState, action: PayloadAction<OrderModel>): void {
    const updatedOrder = action.payload;
    const updatedOrderIndex = state.ordersData.orders.findIndex(order => order.orderId === updatedOrder.orderId);

    state.ordersData.orders[updatedOrderIndex] = updatedOrder;
}

export function onChangeOrderSelection (state: OrdersState, action: PayloadAction<number>): void {
    const orderToEdit = state.ordersData.orders.find(order => order.orderId === action.payload);

    if (orderToEdit) {
        orderToEdit.isSelected = !orderToEdit.isSelected;
    }
    state.hasAllSelected = state.ordersData.orders.every(order => order.isSelected);
}

export function onSelectAll (state: OrdersState, action: PayloadAction<boolean>): void {
    state.ordersData.orders.forEach(order => {
        order.isSelected = action.payload;
    })

    state.hasAllSelected = state.ordersData.orders.every(order => order.isSelected);
}

export function onSetIsLoading (state: OrdersState, isLoading: boolean): void {
    state.isLoading = isLoading;
}

export function onChangeOrderView (state: OrdersState, action: PayloadAction<OrderViewEnum>): void {
    state.orderViewType = action.payload;
    state.ordersData.currentPage = 0;

    state.ordersData.orders.forEach(order => {
        order.isSelected = false;
    })
    state.hasAllSelected = false;
}

export function onFilterChange (state: OrdersState, action: PayloadAction<any>): void {
    state.filter = action.payload;
}

export function getOrdersPending (state: OrdersState, isLoading: boolean): void {
    state.isLoading = isLoading;
}

export function getOrdersFulfilled (state: OrdersState, orders: any): void {
    const currentPage = orders.totalItems <= state.ordersData.totalItems ? state.ordersData.currentPage : 0;

    state.ordersData = {...orders, currentPage};
    state.isLoading = false;
}

export function getAllOrdersFulfilled (state: OrdersState, orders: any): void {
    state.allOrdersData = {...orders};
    state.isLoading = false;
}

export function getOrdersRejected (state: OrdersState): void {
    state.ordersData.orders = [];
    state.ordersData.currentPage = 0;
    state.ordersData.totalItems = 0;
    state.isLoading = false;
}

export function getAllOrdersRejected (state: OrdersState): void {
    state.allOrdersData.orders = [];
    state.allOrdersData.totalItems = 0;
    state.isLoading = false;
}

export function getOrdersStatesSummaryPending (state: OrdersState, isLoading: boolean): void {
    state.summaryIsLoading = isLoading;
}

export function getOrdersStatesSummaryFulfilled (state: OrdersState, summary: any): void {
    const stateSummaries = {} as {[key: string | number]: number};

    summary.forEach((stateData: {stateId:number | string, count: number}) => {
        stateSummaries[stateData.stateId] = stateData.count;
    })
    state.ordersStateSummary = stateSummaries;
    state.summaryIsLoading = false;
}

export function getOrdersStatesSummaryRejected (state: OrdersState): void {
    state.ordersStateSummary = {};
    state.summaryIsLoading = false;
}

export function getOrderByIdPending (state: OrdersState): void {
    state.isLoading = true; // TODO: implement or remove
}

export function getOrderByIdFulfilled (state: OrdersState): void {
    state.isLoading = false; // TODO: implement or remove
}

export function getOrderByIdRejected (state: OrdersState): void {
    state.isLoading = false; // TODO: implement or remove
}

export function getOldestInWarehouseOrderFulfilled (state: OrdersState, oldestDate: string): void {
    state.oldestInWarehouseOrderDate = oldestDate;
    state.summaryIsLoading = false;
}

export function onFlushOrderData (state: OrdersState): void {
    // TODO: REMOVE?
}

export interface OrdersState {
    tabId: number;
    typeId: number;
    orderStateId: number | string;
    filter: OrderFilterModel,
    ordersData: OrdersResponseModel;
    allOrdersData: AllOrdersResponseModel;
    ordersStateSummary: {[key: number | string]: number},
    oldestInWarehouseOrderDate: string,
    orderViewType: OrderViewEnum,
    isLoading: boolean;
    summaryIsLoading: boolean;

    hasAllSelected: boolean,
}

